import React from 'react'
import { Icon as AccountCircleIcon } from 'images/account-circle.svg'
import { useAuth0 } from '@auth0/auth0-react'
import { clearSessionToken } from '../services/auth'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

function AccountDetails({ isAdmin }) {
  const { logout } = useAuth0()

  function handleLogout() {
    clearSessionToken()
    logout({
      logoutParams: { returnTo: window.location.origin },
    }).catch(() => {})
  }

  return (
    <div className="account-details">
      <DropdownMenu.Root modal={false}>
        <DropdownMenu.Trigger asChild>
          <button
            type="button"
            className="account-details-icon-btn"
            aria-label="view account options"
          >
            <AccountCircleIcon />
          </button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content
            className="account-details--dropdown"
            align="end"
            sideOffset={10}
          >
            <DropdownMenu.Item asChild className="menu-item">
              <Link to="/profile/details">My profile</Link>
            </DropdownMenu.Item>
            {isAdmin && (
              <DropdownMenu.Item asChild className="menu-item">
                <Link to="/company">Manage account</Link>
              </DropdownMenu.Item>
            )}
            <DropdownMenu.Item onSelect={handleLogout} className="menu-item">
              Log out
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  )
}

AccountDetails.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
}

export default AccountDetails
